import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=0aac4a2a&"
import script from "./Reset.vue?vue&type=script&lang=ts&"
export * from "./Reset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports